export const menuCollection = {
  'menu-collection.collections': 'Collections',
  'menu-collection.more-collections': 'More collections',
};
